import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Teams } from '../../../model';

@Injectable()
export class TeamSummaryService {
  model = new Teams([]);

  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: Http,
    private httpClient: HttpClient
  ) { }

  getSummary(): Observable<any> {
    const url = this.urlPrefix + 'teams';
    return this.httpClient
      .get(url,
        {
          observe: 'response',
        })
      .map(
        res => {
          if (res.status === 200) {
            this.model.setValue(res.body);
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err.error);
        }
      );
  }

  getTechnicianSummary(teamIds: number[]): Observable<any> {
    const url = this.urlPrefix + 'teams/get-teams';
    return this.httpClient
      .post(url, teamIds,
        {
          observe: 'response',
        })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err.error);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/team-summary.service.ts